import { getValidJwtCookie } from '@/utils/cookies'

export function shouldFetchOTA() {
  return !!getValidJwtCookie()
}
